var _path, _path2, _path3, _polygon, _polygon2, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8SaintKittsAndNevisCircular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M10.729,38.943L42.672,16.91c-1.297-3.415-3.492-6.38-6.311-8.605L4.908,30 C6.007,33.498,8.053,36.567,10.729,38.943z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd600",
    d: "M42.657,16.92l-31.92,22.017c0.695,0.619,1.418,1.207,2.197,1.724l30.551-21.073 C43.278,18.669,42.986,17.786,42.657,16.92z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd600",
    d: "M36.337,8.321c-0.746-0.588-1.519-1.143-2.345-1.622L4.269,27.201 c0.154,0.951,0.396,1.87,0.678,2.772L36.337,8.321z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#eceff1",
    points: "13.926,24.676 16.675,26.718 19.514,24.804 18.422,28.049 21.119,30.158 17.696,30.122 16.523,33.339 15.499,30.072 12.078,29.951 14.868,27.968"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#eceff1",
    points: "28.756,14.42 31.505,16.461 34.344,14.548 33.252,17.793 35.949,19.901 32.525,19.866 31.353,23.083 30.329,19.816 26.908,19.695 29.698,17.711"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#2e7d32",
    d: "M3.989,24c0,1.092,0.111,2.157,0.28,3.201L33.992,6.699C31.047,4.993,27.638,4,23.989,4 C12.944,4,3.989,12.954,3.989,24z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#d50000",
    d: "M23.989,44c11.046,0,20-8.954,20-20c0-1.518-0.184-2.99-0.504-4.412L12.934,40.662 C16.102,42.768,19.9,44,23.989,44z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8SaintKittsAndNevisCircular);
export default __webpack_public_path__ + "static/media/icons8-saint-kitts-and-nevis-circular.4a469aba74ddd1e619d44ffb4c1b3058.svg";
export { ForwardRef as ReactComponent };